import { X } from 'lucide-react';

const GUIDE_STEPS = [
  {
    emoji: '🗺️',
    title: '혼잡도 지도',
    desc: '서울 주요 장소의 실시간 혼잡도를 색상으로 확인하세요.\n🟢 여유 · 🟡 보통 · 🟠 약간 붐빔 · 🔴 붐빔 · ⚫ 매우 붐빔',
  },
  {
    emoji: '📍',
    title: '마커 탭하기',
    desc: '지도 위 마커를 탭하면 장소 상세 정보와 현재 혼잡도 단계를 확인할 수 있습니다.',
  },
  {
    emoji: '🚗',
    title: '길 안내',
    desc: '마커 상세 화면에서 도보 또는 차량 길 안내를 시작할 수 있습니다.\n카카오맵 앱과 연동됩니다.',
  },
  {
    emoji: '🆘',
    title: 'SOS 긴급 연락',
    desc: '하단의 빨간 ! 버튼을 탭하면 설정된 비상 연락처로 빠르게 전화할 수 있습니다.\n설정 → 비상 연락처에서 저장하세요.',
  },
  {
    emoji: '👥',
    title: '그룹 생성',
    desc: '설정 → 그룹에서 가족·친구 그룹을 만들어 위치를 공유할 수 있습니다.\n그룹원의 실시간 위치를 지도에서 함께 확인하세요.',
  },
  {
    emoji: '📨',
    title: '친구 초대',
    desc: '설정 → 친구 초대에서 지인에게 앱 추천 문자를 보낼 수 있습니다.\n주소록에서 바로 연락처를 선택할 수 있어요.',
  },
  {
    emoji: '🔍',
    title: '필터 사용',
    desc: '상단 필터 칩으로 경찰서, 병원, 대사관 등 장소 유형별로 필터링할 수 있습니다.',
  },
  {
    emoji: '🌐',
    title: '언어 변경',
    desc: '설정 → 언어에서 한국어, English, 日本語, 中文, Español 중 선택할 수 있습니다.',
  },
];

/**
 * 앱 사용 방법을 카드 형태로 안내하는 모달
 */
export default function AppGuideModal({ onClose }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex',
        alignItems: 'flex-end',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%',
          maxHeight: '80dvh',
          background: 'var(--color-surface)',
          borderRadius: '20px 20px 0 0',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 20px 12px',
          borderBottom: '1px solid var(--color-border)',
          flexShrink: 0,
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700, color: 'var(--color-navy)' }}>
              📱 앱 사용법
            </h2>
            <p style={{ margin: '2px 0 0', fontSize: '0.78rem', color: 'var(--color-text-muted)' }}>
              주요 기능을 확인해보세요
            </p>
          </div>
          <button
            onClick={onClose}
            id="btn-guide-close"
            aria-label="사용법 닫기"
            style={{
              background: 'var(--color-surface-alt)',
              border: 'none',
              borderRadius: '50%',
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <X size={18} color="var(--color-text-muted)" />
          </button>
        </div>

        {/* 가이드 카드 목록 */}
        <div style={{ overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {GUIDE_STEPS.map((step, i) => (
            <div
              key={i}
              style={{
                background: 'var(--color-surface-alt)',
                borderRadius: 14,
                padding: '14px 16px',
                display: 'flex',
                gap: 14,
                alignItems: 'flex-start',
              }}
            >
              <span style={{ fontSize: '1.8rem', lineHeight: 1, flexShrink: 0 }}>{step.emoji}</span>
              <div>
                <p style={{ margin: '0 0 4px', fontWeight: 700, fontSize: '0.9rem', color: 'var(--color-navy)' }}>
                  {step.title}
                </p>
                <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--color-text-muted)', lineHeight: 1.5, whiteSpace: 'pre-line' }}>
                  {step.desc}
                </p>
              </div>
            </div>
          ))}

          {/* 하단 여백 */}
          <div style={{ height: 'env(safe-area-inset-bottom)' }} />
        </div>
      </div>
    </div>
  );
}
